// このファイルはビルド時に自動生成されます
export const BUILD_INFO = {
  "buildDate": "2026-10-24T04:13:43.992Z",
  "buildNumber": "20261024.2",
  "commitHash": "fbe28d6"
};
